export default __webpack_public_path__ + "static/media/CSPE.ec6caa3f.jpeg";